import React from 'react';
import {Layout} from 'antd';

const {Footer} = Layout;

const AppFooter = () => {
    return (
        <Footer style={{textAlign: 'center'}}>
            Ant Design Demo ©2024 Created by MZH
        </Footer>
    );
};

export default AppFooter;
